import React, { useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Axios from "axios";

//ACTIONS
import * as AccessModalActions from "../../../envStore/actions/accessModal";
import * as UserActions from "../../../../store/actions/user";

//STYLES
import * as FrontInterfaceStyles from "../styles/frontInterface";

function SignIn() {
    const dispatch = useDispatch();
    const accessModal = useSelector((state) => state.accessModal);

    const [data, setData] = useState({
        valids: {
            email: false
        },
        touched: {
            email: false
        },
        errorOnForm: false
    });
    const [message, setMessage] = useState("text");

    function handleOnChange(event) {
        const { id, value } = event.target;

        const valids = data.valids;

        let isValid = false;
        if (id == "email") {
            if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/gm.test(value)) {
                isValid = true;
            }
        } else {
            if (value != "") {
                isValid = true;
            }
        }

        valids[id] = isValid;

        const allTrue = Object.keys(data.valids).every(function (k) {
            return data.valids[k] === true;
        });

        dispatch(AccessModalActions.UpateEmailAddress(value));

        setData((prevState) => {
            return { ...prevState, valids, errorOnForm: allTrue };
        });
    }

    function handleOnTouch(event) {
        const { id } = event.target;

        const touched = data.touched;
        touched[id] = true;

        setData((prevState) => {
            return { ...prevState, touched };
        });
    }

    function handleOpenRegister() {
        dispatch(AccessModalActions.UpdateScreen("register"));
    }

    function switchAllTouches() {
        const touches = Object.assign(...Object.keys(data.touched).map((k) => ({ [k]: true })));

        setData((prevState) => {
            return { ...prevState, touched: touches };
        });
    }

    function handleKeyPress(event) {
        if (event.key === "Enter") {
            handleNextBtn();
        }
    }

    function handleNextBtn() {
        if (!data.errorOnForm) {
            switchAllTouches();
        } else {
            dispatch(AccessModalActions.UpdateScreen("signIn_Password"));
        }
    }

    return (
        <div>
            <Modal.Header closeButton>
                <Modal.Title>Sign In</Modal.Title>
            </Modal.Header>
            <Modal.Body style={FrontInterfaceStyles.signInLocal_Body}>
                <Form.Group>
                    <Form.Label>Email:</Form.Label>
                    <Form.Control
                        isInvalid={data.touched.email && !data.valids.email ? true : false}
                        type="text"
                        id="email"
                        onChange={handleOnChange}
                        onBlur={handleOnTouch}
                        value={accessModal.email}
                        onKeyPress={handleKeyPress}
                    />
                    <Form.Control.Feedback type="invalid">Please enter a valid email!</Form.Control.Feedback>
                </Form.Group>
                <br />
                <div style={FrontInterfaceStyles.signInLocal_DontHaveAccount}>
                    Don&apos;t have an account? <br />
                    <Button variant={"link"} className="mr-auto" onClick={handleOpenRegister} style={{ textTransform: "capitalize" }}>
                        Register
                    </Button>
                </div>
                {/* <div style={message != "text" ? FrontInterfaceStyles.errorTextShow : FrontInterfaceStyles.errorTextHide}>{message}</div> */}
            </Modal.Body>
            <Modal.Footer style={FrontInterfaceStyles.signInLocal_Footer}>
                <Button onClick={handleNextBtn}>Next</Button>
            </Modal.Footer>
        </div>
    );
}

export default SignIn;
